<template>
  <div class="withdraw-page">
    <van-nav-bar :left-arrow="true" left-text="返回" title="申请提现" fixed :placeholder="true" @click-left="goBack">
      <template #right>
        <van-button size="small" type="default" @click="goToWithdrawRecords" class="records-btn">
          明细
        </van-button>
      </template>
    </van-nav-bar>
    
    <!-- 提现金额卡片 -->
    <div class="withdraw-card">
      <div class="withdraw-header">
        <div class="withdraw-title">可提现金额</div>
        <div class="withdraw-amount">¥{{ availableAmount }}</div>
      </div>
      
      <!-- 后端按可提现订单整批结算，不支持拆分单笔订单金额。 -->
      <div class="withdraw-input">
        <div class="input-title">本次提现（全部可提现订单）</div>
        <div class="input-wrapper">
          <span class="currency-symbol">¥</span>
          <van-field
            v-model="withdrawAmount"
            type="number"
            placeholder="暂无可提现金额"
            class="amount-input"
            :maxlength="10"
            readonly
          />
        </div>
        <div class="input-tips">金额由系统按已解冻订单实时核算</div>
      </div>
      
      <div class="withdraw-input">
        <div class="input-title">选择本次收款方式</div>
        <van-radio-group v-model="receiptId">
          <van-cell v-for="r in receipts" :key="r.id" :title="(r.kind === 'wechat' ? '微信' : '支付宝') + ' · ' + r.name" :label="r.account || '收款二维码'" clickable @click="receiptId = r.id">
            <template #right-icon><van-radio :name="r.id" /></template>
          </van-cell>
        </van-radio-group>
        <van-image v-if="selectedReceipt && selectedReceipt.qr_code" width="120" height="120" fit="contain" :src="selectedReceipt.qr_code" @click="previewReceipt" />
        <van-cell v-if="receiptsLoaded && !receipts.length" title="请先补填收款信息" is-link to="/receipt-info" />
        <p v-if="!receiptsLoaded" class="input-tips">收款信息未加载，请刷新重试</p>
      </div>
      <!-- 提现说明 -->
      <div class="withdraw-notice">
        <div class="notice-title">提现说明</div>
        <div class="notice-content">
          <div class="notice-item">• 提现申请将在1-3个工作日内处理</div>
          <div class="notice-item">• 打款结果将通过公众号通知，请核对实际收款</div>
          <div class="notice-item">• 如有疑问请联系客服</div>
        </div>
      </div>
      
      <!-- 提现按钮 -->
      <div class="withdraw-action">
        <van-button 
          type="primary" 
          size="large" 
          :disabled="!canWithdraw"
          :loading="submitting"
          @click="withdraw"
          class="withdraw-btn"
        >
          确认提现
        </van-button>
      </div>
    </div>
    

  </div>
</template>

<script>
import Api from '@/api-service'
import { receiptRequest } from '@/api-service/receipt'
import { ImagePreview } from 'vant'

export default {
  name: "Withdraw",
  data(){
    return {
      receipts: [], receiptId: null, receiptsLoaded: false, submitting: false,
      amount:0.0,
      tableData:[],
      availableAmount: 0.0, // 可提现金额
      withdrawAmount: '', // 提现金额
    }
  },
  computed: {
    selectedReceipt() { return this.receipts.find(r => r.id === this.receiptId); },
    canWithdraw() {
      const amount = parseFloat(this.withdrawAmount);
      return !this.submitting && this.receiptsLoaded && !!this.selectedReceipt && amount && amount >= 10 && amount <= this.availableAmount;
    }
  },
  created() {
    this.amount = Number(this.$route.query.amount || 0);
    this.availableAmount = this.amount;
    this.withdrawAmount = this.amount > 0 ? this.amount.toFixed(2) : '';
    this.fetchData();
  },
  methods:{
    async fetchData(){
      try {
        const [amountRes, listRes, receiptRes] = await Promise.all([
          Api.getWithdrawAmount({}),
          Api.getWithdrawList({}),
          receiptRequest("/api/receipt/list")
        ]);
        this.availableAmount = Number(amountRes.amount || 0);
        this.withdrawAmount = this.availableAmount > 0 ? this.availableAmount.toFixed(2) : '';
        this.tableData = listRes.list || [];
        this.receipts = receiptRes.list || []; this.receiptsLoaded = true;
        if (!this.selectedReceipt) this.receiptId = this.receipts.length === 1 ? this.receipts[0].id : null;
      } catch (e) {
        this.$toast.fail('提现信息加载失败');
      }
    },
    previewReceipt() { if (this.selectedReceipt) ImagePreview([this.selectedReceipt.qr_code]); },
    async withdraw(){
      if (!this.canWithdraw) return;
      const r = this.selectedReceipt;
      try {
        await this.$dialog.confirm({ title: '确认提现', message: `本次提现 ¥${this.withdrawAmount}\n收款方式：${r.kind === 'wechat' ? '微信' : '支付宝'}\n收款人：${r.name}\n${r.account || '使用页面展示的收款码'}\n请确认收款信息正确。` });
        this.submitting = true;
        await receiptRequest('/api/withdraw/applyWithdraw', { amount: Number(this.withdrawAmount), account_id: r.id, receipt_version: r.version });
        this.$notify({type:'success',message:'申请成功，打款结果将通过公众号通知'});
        this.withdrawAmount = ''; this.availableAmount = 0; await this.fetchData();
      } catch (e) { if (e && e.message) { this.$toast.fail(e.message); await this.fetchData(); } } finally { this.submitting = false; }
    },
    goToWithdrawRecords() {
      this.$router.push('/withdraw-records');
    },
    goBack(){
      this.$router.go(-1);
    },
  }
}
</script>

<style scoped lang="scss">
.withdraw-page {
  min-height: 100vh;
  background-color: #f8f9fa;
  padding-bottom: 20px;

  .withdraw-card {
    background: white;
    margin: 16px;
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;

          .withdraw-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        padding: 20px 20px;
        text-align: center;

        .withdraw-title {
          font-size: 15px;
          font-weight: 500;
          margin-bottom: 6px;
          opacity: 0.9;
          letter-spacing: 0.3px;
        }

        .withdraw-amount {
          font-size: 28px;
          font-weight: 700;
          letter-spacing: 0.5px;
        }
      }

    .withdraw-input {
      padding: 16px 20px;

      .input-title {
        font-size: 15px;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 10px;
        letter-spacing: 0.3px;
      }

      .input-wrapper {
        display: flex;
        align-items: center;
        border: 1.5px solid #e8e8e8;
        border-radius: 10px;
        padding: 0 12px;
        background: #fafbfc;
        transition: all 0.3s ease;

        &:focus-within {
          border-color: #667eea;
          background: white;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .currency-symbol {
          font-size: 16px;
          font-weight: 600;
          color: #2c3e50;
          margin-right: 6px;
        }

        .amount-input {
          flex: 1;
          
          ::v-deep .van-field__control {
            border: none;
            background: transparent;
            font-size: 16px;
            font-weight: 600;
            color: #2c3e50;
            padding: 8px 0;
            cursor: pointer;
          }
        }
      }

      .input-tips {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;
        font-size: 12px;
        color: #8a94a3;
      }
    }

    .withdraw-notice {
      padding: 0 20px 16px;

      .notice-title {
        font-size: 15px;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 10px;
        letter-spacing: 0.3px;
      }

      .notice-content {
        .notice-item {
          font-size: 13px;
          color: #7f8c8d;
          line-height: 1.5;
          margin-bottom: 6px;
          font-weight: 400;
        }
      }
    }

    .withdraw-action {
      padding: 0 20px 16px;

      .withdraw-btn {
        width: 100%;
        height: 44px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        border-radius: 10px;
        font-size: 15px;
        font-weight: 600;
        color: white;
        box-shadow: 0 3px 10px rgba(102, 126, 234, 0.25);
        transition: all 0.3s ease;
        letter-spacing: 0.3px;

        &:active {
          transform: translateY(1px);
          box-shadow: 0 2px 6px rgba(102, 126, 234, 0.3);
        }

        &:disabled {
          background: #e8e8e8;
          color: #bdc3c7;
          box-shadow: none;
          transform: none;
        }
      }
    }
  }

  .records-btn {
    font-size: 12px;
    height: 28px;
    padding: 0 12px;
    border-radius: 6px;
    border: 1px solid #667eea;
    background: white;
    color: #667eea;
    font-weight: 500;
    transition: all 0.3s ease;

    &:active {
      background: rgba(102, 126, 234, 0.1);
      transform: scale(0.95);
    }
  }
}
</style>
